<template>
<layout-content>
  <template #toolbar>
    <compare-time
      :query="query"
      :start-date-picker-options="startDatePickerOptions"
      :end-date-picker-options="endDatePickerOptions"
      :query-flag.sync="queryFlag"
      style="float:left;margin-left:1em;"
      @dimension-changed="onGranularityChanged"
    >
      <template>
        <site-query :sites="filterSites" :query="query" />

        <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

        <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

        <el-button
          :disabled="canNotSearch"
          type="orange"
          size="small"
          icon="el-icon-search"
          @click="onSearchBtnClick"
        >查询</el-button>
      </template>
    </compare-time>
  </template>

  <template #body>
    <data-wrapper
      v-if="currentQuery.granularity === 'day' || currentQuery.granularity === 'month'"
    >
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          style="margin-left:20px;"
          @change="onUnitPropChange"
        />
      </template>

      <data-item
        v-for="data in dataList"
        :key="data.siteId"
        :title="data.siteName"
      >
        <v-o-cs-category-bar-chart ref="charts" :data="data" />
      </data-item>
    </data-wrapper>

    <data-wrapper v-else>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          style="margin-left:20px;"
          @change="onUnitPropChange"
        />
      </template>

      <section style="height:450px;">
        <v-o-cs-category-site-bar-chart ref="charts" :data="dataList" />
      </section>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseNormal from '../../../../06Data-Management/02Normal/BaseNormal'
import LayoutContent from '../../../../../components/Layout/Content'
import VOCsChart from '../../../../../components/Data/FactorCharts/VOCsChart'
import CompareTime from '../../../../../components/Data/CompareTime'
import VOCsCategoryBarChart from './VOCsCategoryBarChart'
import VOCsCategorySiteBarChart from './VOCsCategorySiteBarChart'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import DataItem from '../../../../../components/Data/DataItem'

export default {
  name: 'DataManagementVOCsCategoryCompare',
  routeInfo: {
    label: 'VOCs分类比较',
    icon: 'fa fa-users'
  },
  extends: BaseNormal,
  components: {
    DataItem,
    DataWrapper,
    VOCsCategorySiteBarChart,
    VOCsCategoryBarChart,
    CompareTime,
    VOCsChart,
    LayoutContent
  },
  data () {
    return {
      query: {
        granularity: 'month',
        queryTimes: [],
        unit: '',
        isMultipleIntegral: true,
        isFuse: false,
        isGetInvalidData: true
      },
      selectFactorTree: {},
      currentQuery: {},
      queryFlag: true
    }
  },
  computed: {
    siteDeviceCategory: () => process.env.ALL_VOCS_DEVICE_CATEGORY,
    displayUnit () {
      let factorId = this.filterFactors[0].id
      let factor = this.factorMap[factorId]
      return factor[this.unitProp]
    },
    canNotSearch () {
      let {query} = this
      return query.siteIds.length === 0 || !this.queryFlag
    }
  },
  methods: {
    onAuditCompletedChanged () {
      let {query} = this
      query.isAuditCompleted ? query.isGetInvalidData = false : query.isGetInvalidData = true
      if (query.isAuditCompleted === 'isFuse') {
        query.isFuse = true
        delete query.isAuditCompleted
      } else {
        query.isFuse = false
      }
      this.getData()
    },
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false
    //   this.getData()
    // },
    onSitesChanged () {
      let {filterSites, query: {siteIds}} = this

      if (filterSites.length > 0) {
        if (siteIds.length === 0) {
          siteIds.push(filterSites[0].id)
        }
      } else {
        return
      }

      setTimeout(() => {
        this.getData()
      }, 0)
    },
    getData () {
      let {query} = this
      query.unit = this.displayUnit
      let currentQuery = this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
      this.changeLoadStatus(true)
      this.$api.Data.getStatisticAnalysisGranularityVOCsData(currentQuery).then(dataList => {
        this.tmpList = dataList
        this.formatData()
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onUnitPropChange () {
      if (!this.canNotSearch) {
        this.getData()
      }
    },
    formatData () {
      let {currentQuery, filterSiteMap, factorGroupMap, tmpList} = this
      let factorGroups = this.filterFactorGroups = [...new Set(tmpList.map(data => data.groupId))].map(factorGroupId => factorGroupMap[factorGroupId])
      let {queryTimes} = currentQuery
      let dataMap = currentQuery.siteIds.reduce((map, siteId) => {
        map[siteId] = {
          siteId,
          siteName: filterSiteMap[siteId].name,
          data: queryTimes.reduce((map, queryTime) => {
            map[queryTime] = factorGroups.reduce((map, factorGroup) => {
              map[factorGroup.id] = null
              return map
            }, {})
            return map
          }, {})
        }
        return map
      }, {})

      tmpList.forEach(data => {
        let siteDataMap = dataMap[data.siteId]

        if (!siteDataMap) {
          return
        }

        let dataTimeDataMap = siteDataMap.data[data.dataTimeStr]

        if (!dataTimeDataMap) {
          return
        }

        dataTimeDataMap[data.groupId] = {
          value: data.value,
          isHaveIntegral: data.isHaveIntegral || false
        }
      })

      this.dataList = Object.freeze(Object.values(dataMap))
      this.granularityLabel = this.tmpGranularityLabel
    },
    renderData () {
      setTimeout(() => {
        let charts = this.$refs.charts
        let {currentQuery} = this
        let data = {
          factorGroups: this.filterFactorGroups,
          dataTimes: [...currentQuery.queryTimes],
          unit: currentQuery.unit,
          chartTitle: `VOCs${this.granularityLabel}统计`
        }

        if (Array.isArray(charts)) {
          charts.forEach(chart => chart.render(data))
        } else {
          charts.render(data)
        }
      }, 0)
    },
    onGranularityChanged (param) {
      this.tmpGranularityLabel = param.label
    }
  }
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  .site-data {
    & + .site-data {
      margin-top: 20px;
    }
  }

  .site-data-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }

  .site-data-body {
    height: 400px;
  }
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/03VOCs-Category-Compare/index.vue